// addEventListener('load', () => {
//     initParallaxEffect('#career-id', '#career-image-id', 350);
// });

function setupParallaxOnce() {
    const screenWidth = window.innerWidth;

    if (screenWidth >= 1399) {
        initParallaxEffect('#career-id', '#career-image-id', 350);
    } else if (screenWidth >= 991) {
        initParallaxEffect('#career-id', '#career-image-id', 200);
    } else if (screenWidth >= 860) {
        initParallaxEffect('#career-id', '#career-image-id', 100);
    } else {
        initParallaxEffect('#career-id', '#career-image-id', 0);
    }
}

window.addEventListener('load', setupParallaxOnce);
window.addEventListener('resize', setupParallaxOnce);